import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Table, TableBody, TableContainer, TableHead, TableRow } from "@mui/material";
import "./CompanyDetailModal.css";
import { HEAD_DETAIL_COMPANY } from "constants/data";
import TableRowComponent from "components/table/TableRowComponent";
import TableCellComponent from "components/table/TableCellComponent";
import CancelButton from "components/button/CancelButton";
import { CompanyType } from "../types/company";

interface UserCreateModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedCompany: CompanyType;
}

/**
 * CompanyDetailModal Component
 *
 * This component renders a modal displaying detailed information about a company.
 * It includes a table with company details and a cancel button to close the modal.
 * @param {object} props - The props for the component.
 * @param {boolean} props.isOpen - Controls the visibility of the modal.
 * @param {() => void} props.onClose - Callback function to close the modal.
 * @param {CompanyType} props.selectedCompany - The selected company data to display in the modal.
 */
export default function CompanyDetailModal({
  isOpen,
  onClose,
  selectedCompany,
}: UserCreateModalProps) {
  return (
    <Modal
      sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      open={isOpen}
      onClose={onClose}
    >
      <Box
        sx={{
          maxHeight: "90vh",
          overflow: "auto",
          width: { xs: "90%", md: "80%" },
          maxWidth: "870px",
          backgroundColor: "var(--white)",
          padding: { xs: 3, md: 4, xl: "30px 70px" },
          borderRadius: "21px",
          display: "flex",
          flexDirection: "column",
          rowGap: "20px",
        }}
      >
        <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom="30px">
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: "fontWeightMedium",
              color: "var(--gray-700)",
              marginRight: "27px",
              fontSize: "33px",
            }}
          >
            店舗得意先一覧
          </Typography>
          <CancelButton onClose={onClose} />
        </Box>
        <TableContainer
          component={Table}
          sx={{
            boxShadow: "none",
            width: "100%",
            minWidth: 400,
            borderCollapse: "unset",
            borderSpacing: "2px 1px",
          }}
        >
          <TableHead>
            <TableRowComponent data={HEAD_DETAIL_COMPANY} type="header" />
          </TableHead>
          <TableBody>
            {selectedCompany.store_or_client?.map((item) => (
              <TableRow key={`${item.store_cd}-${item.client_cd}`}>
                <TableCellComponent
                  sx={{
                    backgroundColor: "var(--offwhite-400)",
                    border: "2px solid var(--silver-150)",
                  }}
                >
                  {item.store_cd}
                </TableCellComponent>
                <TableCellComponent
                  sx={{
                    backgroundColor: "var(--offwhite-400)",
                    border: "2px solid var(--silver-150)",
                  }}
                >
                  {item.client_cd}
                </TableCellComponent>
                <TableCellComponent
                  sx={{
                    backgroundColor: "var(--offwhite-400)",
                    border: "2px solid var(--silver-150)",
                  }}
                >
                  {item.store_name}
                </TableCellComponent>
              </TableRow>
            ))}
          </TableBody>
        </TableContainer>
        <CancelButton onClose={onClose} />
      </Box>
    </Modal>
  );
}
